import React from 'react';
import { Grid, Box, Card, CardContent } from "@mui/material";
import { ComTypography } from '../commonFields/ComTypography';
import useMediaQuery from '@mui/material/useMediaQuery';
import "./../about/Aboutus.css";
import cycle from "./../images/cycle.jpg";
import "./Style.css";


const MicrosoftCycle = () => {
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  const microsoftCycle = {
    display: "flex",
    margin: 'auto', padding: vMediaQuery ? "0px" : "16px",
    backgroundColor: "#f5faff",
    border: "1px solid #357ec7",
    boxShadow: vMediaQuery ? "8px 8px rgba(152, 183, 214, 0.6)" : "16px 16px rgba(152, 183, 214, 0.6)" // Blue shadow effect
  }

  const explore = {
    padding: vMediaQuery ? "0px" : "20px 60px 20px 90px"
  }
  return (
    <Box sx={{ flexGrow: 1, padding: vMediaQuery ? "30px 20px" : "50px 80px", backgroundColor: "#edf0f2" }}>
      <Card className='cards' style={microsoftCycle}>
        <CardContent>
          <Grid container spacing={vMediaQuery ? 2 : 0}>
            <Grid item xs={12} md={8} lg={8} sx={explore}>
              <h1 className='headingCycle'>Power your business forward with the<br /> right technology and expertise</h1>
              <ComTypography variant={"body1"} text={"Implementing great technology is the first step. Go faster and further with Dynamics 365. Our unmatched attention to detail, client friendly approach, innovative solutions and deep experience in the Microsoft ecosystem has enabled several businesses to achieve success with the Microsoft platform."} />
            </Grid>
            <Grid item xs={12} md={4} lg={4} >
              <div className="headimg-contanier">
                <img className="headImg" alt="explore" src={cycle} />
              </div>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}

export default MicrosoftCycle;